import React from 'react'
import { useDispatch } from 'react-redux'
import t from '../../i18n/translations/translations'
import './TributariaModal.css'
import Cross from '../../assets/svg/Cross'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { MI_PAGO_HARTU_FUNCIONALITY } from '../../constants/hartu'
import { tributariaPayNow, tributariaPayLater } from '../../store/actions'
import InfoPay from '../../assets/svg/hartu/InfoPay'
import { useNavigate } from 'react-router-dom'
import { useLoading } from '../../context/LoadingContext/LoadingContext';

function TributariaModal({
    isOpened,
    handleClose,
    instanceID,
    id_booking = null,
    id_user = null,
    total_price,
    tributaria_price,
    lang,
    id_facility,
    id_facility_type = null,
    bookingDate,
    startBookingHour,
    name,
    lastname,
    email,
    dni,
    cp,
    phone,
    people,
    hasLightCheck,
    hidePayLaterButton,
    facilityName,
    numPellets,
    dynamicsFields
}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { setLoading } = useLoading();

    const handlePayNow = () => {
        setLoading(true);
        dispatch(
            tributariaPayNow({
                id_instancia: instanceID,
                id_user: id_user,
                total_price: tributaria_price,
                id_booking: id_booking,
                functionality_type: MI_PAGO_HARTU_FUNCIONALITY,
                lang: lang,
                id_facility: id_facility,
                id_facility_type: id_facility_type,
                bookingDate: bookingDate,
                startBookingHour: startBookingHour,
                name: name,
                lastname: lastname,
                email: email,
                dni: dni,
                cp: cp,
                phone: phone,
                people: people,
                hasLightCheck: hasLightCheck,
                num_pellets: numPellets,
                dynamicsFields: dynamicsFields
            }, setLoading, handleClose)
        )
    }

    // Función para manejar el pago posterior
    const handlePayLater = async () => {
        try {
            setLoading(true);
            const success = dispatch(
                tributariaPayLater({
                    id_instancia: instanceID,
                    id_user: id_user,
                    total_price: tributaria_price,
                    id_booking: id_booking,
                    functionality_type: MI_PAGO_HARTU_FUNCIONALITY,
                    lang: lang,
                    id_facility: id_facility,
                    id_facility_type: id_facility_type,
                    bookingDate: bookingDate,
                    startBookingHour: startBookingHour,
                    name: name,
                    lastname: lastname,
                    email: email,
                    dni: dni,
                    cp: cp,
                    phone: phone,
                    people: people,
                    hasLightCheck: hasLightCheck,
                    num_pellets: numPellets,
                    dynamicsFields: dynamicsFields
                }, setLoading, handleClose)
            )
            if (success == true) {
                navigate('/thank-you')
            }
        } catch (error) {
            navigate('/hartu/pago-error')
        }
    }

    return (
        <Dialog
            id="dialog-content"
            open={isOpened}
            onClose={handleClose}
            className="dialogContainer priceChanged"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Button onClick={handleClose} className="closeButton">
                <Cross width="20px" />
            </Button>
            <DialogTitle id="alert-dialog-title">
                <>
                    <div className="alert-dialog-title-message">{t.datos_reserva["eu"]}</div>
                    <div className="alert-dialog-title-message-subtitle">{t.datos_reserva["es"]}</div>
                </>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="hartuBookingform__confirmation">
                        <h3>{t.datos_reserva[lang]}</h3>
                        <div className="hartuBookingform__confirmation_content_modal">
                            <div>
                                <i className="fa-solid fa-building fa-lg" />
                                <p>{facilityName}</p>
                            </div>
                            <div>
                                <i className="fa fa-calendar fa-lg" />
                                <div className='diplayBlock'>
                                    {bookingDate.map((date, index) => (
                                        <div key={index}>
                                            
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="withoutDiscount">
                                <i className="fa fa-credit-card fa-lg" />
                                <label>{t.price_anterior[lang]}</label>
                                <p style={{ marginLeft: '8px' }}>{`${total_price} €`}</p>
                            </div>
                            <div>
                                <i className="fa fa-credit-card fa-lg" />
                                <p>{t.price_actualizado_tributaria[lang]}</p>
                                <p style={{ marginLeft: '8px' }}>{`${tributaria_price} €`}</p>
                            </div>
                        </div>
                        <div></div>
                    </div>
                </DialogContentText>
                <div id="form-content" className="tributariaPayButtons">
                    <Button onClick={handlePayNow} className="payBookingButton">
                        {t.pay_now[lang]}
                    </Button>
                    {id_user != null && !hidePayLaterButton && (
                        <Button
                            onClick={handlePayLater}
                            className="payBookingButton"
                        >
                            {t.pay_later[lang]}
                        </Button>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default TributariaModal
